import { Params } from "react-router-dom";

export function getBasePathFromParam(params: Readonly<Params<string>>): string {
    const edition = params.edition || 'common';
    const prefix = (params.prefix && `/${params.prefix}`) || '';
    return `${prefix}/${edition}`;
}